import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "calendar" }
const _hoisted_2 = { class: "notes-month" }

import AccountPagePatternLayout from "./AccountPagePatternLayout.vue";
import { useStore } from "vuex";
import { computed } from "vue";
import i18n from "@/services/i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'AccountCalendarWork',
  setup(__props) {

const store = useStore();
const locale = computed(() => store.getters["locale/locale"]);

return (_ctx: any,_cache: any) => {
  const _component_a_calendar = _resolveComponent("a-calendar")!

  return (_openBlock(), _createBlock(AccountPagePatternLayout, {
    title: _ctx.$t('nav.account.calendarWork')
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_calendar, { locale: locale.value }, {
          monthCellRender: _withCtx(({ current }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("section", null, _toDisplayString(current), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t("ACCOUNT_SECTION.BACKLOG_NUMBER")), 1)
            ])
          ]),
          _: 1
        }, 8, ["locale"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})